import React from 'react';

const Warning = ({ fill = "#00999e" }) => (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="26" height="26" rx="13" fill={fill} />
        <path d="M13.4998 15.2702L13.4598 15.7102H10.7398L10.6998 15.2702C10.6998 13.1302 10.7398 12.1702 12.8798 11.2502L13.6798 10.9102C14.3798 10.5302 14.4198 10.2502 14.4198 9.81018C14.4198 9.21018 13.8398 8.73018 12.9998 8.73018C12.1598 8.73018 11.5798 9.27018 11.5798 10.1102H8.77979C8.77979 7.55018 10.4998 5.93018 12.9998 5.93018C15.4998 5.93018 17.2198 7.43018 17.2198 9.83018C17.2198 11.7702 16.0998 13.1302 14.5398 13.6102C13.7198 13.8502 13.4998 14.3302 13.4998 15.2702ZM10.4198 18.3902C10.4198 17.4302 11.1998 16.7302 12.1398 16.7302C13.0798 16.7302 13.8798 17.4302 13.8798 18.3902C13.8798 19.3702 13.0798 20.0702 12.1398 20.0702C11.1998 20.0702 10.4198 19.3702 10.4198 18.3902Z" fill="white" />
    </svg>
);

const Confirmed = ({ fill = "#00999e" }) => (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="26" height="26" rx="13" fill={fill} />
        <path fillRule="evenodd" clipRule="evenodd" d="M18.3463 9.69177C18.6116 9.34029 18.5417 8.84031 18.1903 8.57503C17.8388 8.30975 17.3388 8.37963 17.0735 8.7311L11.9301 15.5459L8.87608 12.2365C8.57744 11.9129 8.07301 11.8926 7.7494 12.1913C7.42578 12.4899 7.40554 12.9944 7.70418 13.318L11.4057 17.329C11.7043 17.6526 12.2087 17.6729 12.5323 17.3742C12.5746 17.3352 12.6117 17.2927 12.6436 17.2476L18.3463 9.69177Z" fill="white" />
        <path d="M18.1903 8.57503L17.889 8.97412L17.889 8.97412L18.1903 8.57503ZM18.3463 9.69177L17.9472 9.39055L17.9472 9.39055L18.3463 9.69177ZM17.0735 8.7311L17.4726 9.03232V9.03232L17.0735 8.7311ZM11.9301 15.5459L11.5626 15.885L11.9685 16.3248L12.3291 15.8471L11.9301 15.5459ZM8.87608 12.2365L9.24353 11.8974L9.24353 11.8974L8.87608 12.2365ZM7.7494 12.1913L7.41031 11.8238H7.41031L7.7494 12.1913ZM7.70418 13.318L7.33673 13.6571H7.33673L7.70418 13.318ZM11.4057 17.329L11.0382 17.6681H11.0382L11.4057 17.329ZM12.5323 17.3742L12.1933 17.0068L12.1933 17.0068L12.5323 17.3742ZM12.6436 17.2476L12.2445 16.9463L12.2397 16.9527L12.2351 16.9592L12.6436 17.2476ZM17.889 8.97412C18.0201 9.07304 18.0462 9.25949 17.9472 9.39055L18.7454 9.99298C19.177 9.42109 19.0634 8.60758 18.4915 8.17594L17.889 8.97412ZM17.4726 9.03232C17.5715 8.90125 17.758 8.87519 17.889 8.97412L18.4915 8.17594C17.9196 7.74431 17.1061 7.858 16.6744 8.42989L17.4726 9.03232ZM12.3291 15.8471L17.4726 9.03232L16.6744 8.42989L11.531 15.2446L12.3291 15.8471ZM12.2975 15.2068L9.24353 11.8974L8.50864 12.5756L11.5626 15.885L12.2975 15.2068ZM9.24353 11.8974C8.75762 11.3709 7.93686 11.3379 7.41031 11.8238L8.08849 12.5587C8.20916 12.4474 8.39727 12.4549 8.50864 12.5756L9.24353 11.8974ZM7.41031 11.8238C6.88376 12.3097 6.85082 13.1305 7.33673 13.6571L8.07163 12.9789C7.96026 12.8582 7.96781 12.6701 8.08849 12.5587L7.41031 11.8238ZM7.33673 13.6571L11.0382 17.6681L11.7731 16.9899L8.07162 12.9789L7.33673 13.6571ZM11.0382 17.6681C11.5241 18.1946 12.3449 18.2276 12.8714 17.7417L12.1933 17.0068C12.0726 17.1181 11.8845 17.1106 11.7731 16.9899L11.0382 17.6681ZM12.8714 17.7417C12.9397 17.6787 13 17.6096 13.052 17.5359L12.2351 16.9592C12.2234 16.9758 12.2095 16.9918 12.1933 17.0068L12.8714 17.7417ZM17.9472 9.39055L12.2445 16.9463L13.0427 17.5488L18.7454 9.99298L17.9472 9.39055Z" fill="white" />
    </svg>
);

const CurrentUnconfirmed = ({ size = 26 }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background circle */}
      <circle cx="13" cy="13" r="13" fill="#00999e" />
  
      {/* White outer ring */}
      <circle cx="13" cy="13" r="9" fill="none" stroke="white" strokeWidth="3" />
  
      {/* White pie wedge */}
      <path
        d="M13,13 L13,4 A9,9 0 0,1 21.4,17.4 Z"
        fill="white"
      />
    </svg>
  );

const Unconfirmed = ({ stroke = "#00999e", strokeWidth = 3 }) => (
    <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        xmlns="http://www.w3.org/2000/svg"
    >
        {/* Outer border circle */}
        <circle
            cx="13"
            cy="13"
            r={13 - strokeWidth / 2}
            fill="none"
            stroke={stroke}
            strokeWidth={strokeWidth}
        />
    </svg>
);

const ArrowRight = ({ fill = "#0000006B" }) => (
    <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" width="26" height="26" rx="13" fill={fill}/>
        <path d="M8 12.2524V13.7481H16.3333L12.5139 17.8613L13.5 18.9233L19 13.0002L13.5 7.07715L12.5139 8.13911L16.3333 12.2524H8Z" fill="white"/>
    </svg>
);

const icons = {
    Warning,
    Confirmed,
    Unconfirmed,
    CurrentUnconfirmed,
    ArrowRight
};

export { Warning, Confirmed, Unconfirmed, CurrentUnconfirmed, ArrowRight };
export default icons;



// WEBPACK FOOTER //
// ./src/views/Order/components/_Icon.jsx